import { MessageCircle } from 'lucide-react';

interface DailySummaryCardProps {
  summary: string;
}

const DailySummaryCard = ({ summary }: DailySummaryCardProps) => {
  return (
    <div className="bg-secondary/60 rounded-2xl p-4 border border-primary/10">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-6 h-6 rounded-lg bg-primary/10 flex items-center justify-center">
          <MessageCircle className="h-3.5 w-3.5 text-primary" />
        </div>
        <h2 className="text-sm font-semibold text-secondary-foreground">Resumen del día</h2>
      </div>
      <p className="text-sm text-secondary-foreground/80 leading-relaxed">{summary}</p>
    </div>
  );
};

export default DailySummaryCard;
